<template>
	<div>
		<app-table
			selectable
			class="is-not-selectable pa-4"
			name="action-list"
			:columns="columns"
			:current-page="currentPage"
			:rows="webServices"
			:last-page="lastPage"
			:check-all="checkAll"
			@on-selected-all="allIsSelected"
			@row-is-selected="rowIsSelected"
		>
			<template slot="rows" slot-scope="props">
				<td
					class="is-not-selectable"
				>
					{{ props.row.domain }}
				</td>
				<td>{{ props.row.method }}</td>
				<td>{{ props.row.path }}</td>
				<td>{{ props.row.name }}</td>
				<td>
					<v-checkbox
						class="mt-0 pl-2"
						color="success"
						hide-details
						:disabled="!props.row.isSelected"
						v-model="props.row.authorize">
					</v-checkbox>
				</td>
			</template>
		</app-table>
		<section class="modal-filter-footer">
			<modal-sidebar-button
				:is-loading="false"
				@accept-button-clicked="$emit('save-web-service', webServices)"
				@cancel-button-clicked="$emit('close')"
			>
			</modal-sidebar-button>
		</section>
	</div>
</template>
<script>

function allIsSelected(value) {
	this.$emit('select-all', value);
}

function rowIsSelected(row) {
	this.$emit('row-is-selected', row);
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Dominio', checked: true, visible: true },
			{ id: 2, name: 'Método', checked: true, visible: true },
			{ id: 3, name: 'URI', checked: true, visible: true },
			{ id: 4, name: 'Nombre', checked: true, visible: true },
			{ id: 5, name: 'Auth', checked: true, visible: true },
		],
		currentPage: 1,
		lastPage: 0,
	};
}

export default {
	name: 'resource-search',
	data,
	methods: {
		allIsSelected,
		rowIsSelected,
	},
	props: {
		webServices: {
			default: () => [],
			type: Array,
		},
		checkAll: {
			default: false,
			type: Boolean,
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/resource-service/resource-web-service.vue